<template>
	<v-col class="history-transfer-ewallet">
		<ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Histori Transfer Saldo</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-wallet</v-icon>
			<div class="pl-2">E-wallet</div>
			<div class="px-2">/</div>
			<div>Histori Transfer Saldo</div>
		</div>
		<div class="mt-5">
			<v-row justify="space-between" class="align-center mb-5">
				<v-col cols="12" sm="6" md="4" xl="4" class="">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="2" sm="2" md="2" class="pr-0 my-auto text-center">
								<img class="img-fluid" src="/assets/icon/saldo.png">
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-14 blue--text font-weight-500">{{ ewalletSummary.ewallet_product_balance | toRupiah }}</div>
								<div class="font-size-10 cl-grey">Total Saldo Belanja</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>

				<v-col cols="12" sm="6" md="6" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
						<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
					</div>
				</v-col>
			</v-row>
			<div v-if="!loading">
				<v-row v-if="listHistoriEwallet.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-vo-small table-history-bonus">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left" width="15%">Tanggal</th>
										<th class="text-left" width="15%">Nama Penerima</th>
										<th class="text-left" width="15%">Nama Pengirim</th>
										<th class="text-center" width="15%">Jumlah (Rp)</th>
										<th class="text-left" width="35%">Catatan</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="ewallet in listHistoriEwallet" :key="ewallet.ewallet_product_log_id">
										<td class="text-left">{{ ewallet.ewallet_product_transfer_datetime | tanggaljam }}</td>
										<td class="text-left">
											<div>{{ ewallet.ewallet_product_transfer_receiver_member_name }}</div>
											<div class="cl-primary font-weight-500">{{ ewallet.ewallet_product_transfer_receiver_network_code }}</div>
										</td>
										<td class="text-left">
											<div>{{ ewallet.ewallet_product_transfer_sender_member_name }}</div>
											<div class="cl-primary font-weight-500">{{ ewallet.ewallet_product_transfer_sender_network_code }}</div>
										</td>
										<td class="text-center">
											<div class="pa-1 bg-primary-2 cl-white font-weight-bold rounded-pill">{{ ewallet.ewallet_product_transfer_value | toNumber }}</div>
										</td>
										<td>
											{{ ewallet.ewallet_product_transfer_note }}
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listHistoriEwallet.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada histori yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listHistoriEwallet.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historiEwalletPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ historiEwalletPagination.total_display }} data dari total {{ historiEwalletPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';

export default {
	components: {
		ModalSearch
	},
	data() {
		return {
			loading: false,
			startDate: false,
			dateStart: '',
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			sort: 'ewallet_product_transfer_datetime',
			dir: 'DESC',
			params: [],
		}
	},
	computed: {
		...mapState('ewallet', ['listHistoriEwallet', 'historiEwalletPagination', 'ewalletSummary']),
	},
	methods: {
		...mapActions('ewallet', ['getHistoriTransfer', 'getEwalletSummary']),

		queryStringTransferHistory(value) {
			let parameterObject = {}
			let parameter = '{'

			if (value.params) {
				value.params.forEach((value, index) => {
					for (const [key, val] of Object.entries(value)) {
						parameter += `"filter[${index}][${key}]":"${val}",`
					}
				})
			}
			parameter += `"ewallet_product_transfer_sender_member_name": "${value.ewallet_product_transfer_sender_member_name}", "ewallet_product_transfer_receiver_member_name": "${value.ewallet_product_transfer_receiver_member_name}", "limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`
			parameter += '}'
			parameterObject = JSON.parse(parameter)
			return parameterObject
		},

		async getData() {
			this.loading = await true
			this.getEwalletSummary().then(() => {
				this.getHistoriTransfer(this.queryStringTransferHistory({ewallet_product_transfer_sender_member_name: '', ewallet_product_transfer_receiver_member_name: '', limit:this.limit, page: this.page, params: this.params, sort: this.sort, dir: this.dir})).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
			})
		},

		changePage(page) {
			this.page = page
			this.getData()
		},

		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},

		showSearch() {
			this.$refs.modalSearch.modalShow()
		},
		
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
			this.$refs.modalSearch.reset()
		},

		cari(data) {
			this.params = []
			this.page = 1

			if(data.code.value)
				this.params.push(data.code)
			if(data.codesender.value)
				this.params.push(data.codesender)
			if(data.date.value)
				this.params.push(data.date)
			this.getHistoriTransfer(this.queryStringTransferHistory({ewallet_product_transfer_sender_member_name: data.namesender.value, ewallet_product_transfer_receiver_member_name: data.name.value, limit:this.limit, page: this.page, params: this.params, sort: this.sort, dir: this.dir})).then(() => {
				this.$refs.modalSearch.modalHide()
			})
		},
	},
	
	created(){
		this.$store.dispatch('setPageTitle', `Histori Transfer Saldo`)
		this.getData()
	}
};
</script>